import React, { memo, useEffect } from "react";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import { Table } from "./Table.js";
import { ItemTypes } from "./ItemTypes.js";

function getStyles(left, top, isDragging, isPlaced, height, width) {
  return {
    position: "absolute",
    top: `${Number(top) || 0}px`,
    left: `${Number(left) || 0}px`,
    width: `${Number(width) || 50}px`,
    height: `${Number(height) || 50}px`,
    display: isPlaced ? "block" : "none",
    opacity: isDragging ? 0 : 1,
    zIndex: isDragging ? 20 : 1,
  };
}

const DraggableTable = memo(function DraggableTable({
  id,
  table_name,
  left,
  top,
  height,
  width,
  isPlaced,
  selectedItem,
  selectItem,
  table,
  draggable = true,
}) {
  const safeTable = table || {
    id,
    table_name,
    left,
    top,
    height,
    width,
    isPlaced,
  };

  const safeWidth = Number(width) || Number(safeTable?.width) || 50;
  const safeHeight = Number(height) || Number(safeTable?.height) || 50;

  const [{ isDragging }, drag, preview] = useDrag(
    () => ({
      type: ItemTypes.TABLE,
      item: {
        id,
        left,
        top,
        table_name,
        width: safeWidth,
        height: safeHeight,
      },
      canDrag: () => draggable,
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [id, left, top, table_name, safeWidth, safeHeight, draggable],
  );

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  const handleMouseDown = () => {
    if (typeof selectItem === "function") {
      selectItem(safeTable);
    }
  };

  return (
    <div
      ref={drag}
      style={getStyles(left, top, isDragging, isPlaced, safeHeight, safeWidth)}
      role="DraggableTable"
      onMouseDown={handleMouseDown}
    >
      <Table
        table_name={table_name}
        selectedItem={selectedItem}
        id={id}
        item={safeTable}
        mode="setup"
      />
    </div>
  );
});

export default DraggableTable;
